import { TabItem, TabItemProps } from 'bold-ui'
import { useLocation } from 'react-router'
import { matchPath, NavLink, NavLinkProps } from 'react-router-dom'

export interface TabLinkProps extends TabItemProps, Pick<NavLinkProps, 'to' | 'replace' | 'exact' | 'strict'> {}

export function TabLink(props: TabLinkProps) {
  const location = useLocation()

  const resolvedTo = typeof props.to === 'function' ? props.to(location) : props.to
  const path = typeof resolvedTo === 'string' ? resolvedTo.split('?')[0] : resolvedTo.pathname
  const match = matchPath(location.pathname, {
    path,
    exact: props.exact,
    strict: props.strict,
  })
  const isActive = !!match

  return <TabItem component={!props.disabled ? NavLink : 'span'} active={isActive} {...props} />
}
